import { InvestmentProviderEntity } from '../entities/investment-provider-entity';

export default class State {
  loaded = false;

  items: Array<InvestmentProviderEntity> = [];
}
